<div class="wrapper">
  <div class="top-bar">
    <div class="content" *ngIf="!isTroubleshootRoute">
      <span (click)="goBack()">
        <img class="h-18" src="assets/images/icon/chevronleft.svg" />
        {{ translations['back_label'] }}
      </span>
      <span class="verticle-line"> </span>
      <span (click)="navigateToLandingPage()">
        <img src="assets/images/icon/refresh.svg" />
        {{ translations['restart'] }}
      </span>
    </div>
    <select
      [value]="currentLanguage"
      (change)="languageChange($event)"
      class="select-dropdown"
    >
      <option
        *ngFor="let option of languageOptions"
        [value]="option?.value"
        [selected]="option.value === currentLanguage"
      >
        {{ option.value }}
      </option>
    </select>
  </div>

  <div class="main pt-1">
    <!-- Section for ES2000 Machine Type -->
    <div
      *ngIf="selectedMachineType === this.machineType.ES2000"
      class="overflow-scroll p-2 header"
    >
      <h2 class="header-text">{{ translations['whats_going_on'] }}</h2>
      <div class="dishmachine-container">
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'machine_issue'"
          (click)="selectIssueCategory('machine_issue')"
        >
          <img
            src="assets/images/troubleshooting/machine_issue.png"
            alt="Machine Issue"
          />
          <span>{{ translations['machine_issue'] }}</span>
        </div>
      </div>

      <!-- Section for ES2000 Machine type -->
      <div *ngIf="selectedIssueCategory === 'machine_issue'">
        <div *ngFor="let issue of issuesEs2000">
          <div
            class="form-check"
            (click)="
              issueSelection(issue?.key, issue?.label, this.machineType.ES2000)
            "
          >
            <input
              class="form-check-input me-2"
              type="radio"
              name="exampleRadios"
              [id]="'issue-' + issue?.key"
              [value]="issue?.key"
              [(ngModel)]="issueKey"
              (change)="
                issueSelection(
                  issue?.key,
                  issue?.label,
                  this.machineType.ES2000
                )
              "
            />
            <label class="issue-button mt-3" [for]="'issue-' + issue?.key">{{
              issue?.label[languageIndex]
            }}</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Section for EHT, XLHT & XLRW Machine Type -->
    <div
      *ngIf="
        this.selectedMachineType === this.machineType.EHT ||
        this.selectedMachineType === this.machineType.XLHT ||
        this.selectedMachineType === this.machineType.XLRW
      "
      class="overflow-scroll p-2 header"
    >
      <h2 class="header-text">{{ translations['whats_going_on'] }}</h2>
      <div class="dishmachine-container">
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'machine_issue'"
          (click)="selectIssueCategory('machine_issue')"
        >
          <img
            src="assets/images/troubleshooting/machine_issue.png"
            alt="Machine Issue"
          />
          <span>{{ translations['machine_issue'] }}</span>
        </div>
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'poor_results'"
          (click)="poorResults()"
        >
          <img
            src="assets/images/troubleshooting/poor_result.png"
            alt="Poor Result"
          />
          <label>{{ translations['poor_results'] }}</label>
        </div>
      </div>

      <div *ngIf="selectedIssueCategory === 'machine_issue'">
        <div *ngFor="let issue of issues">
          <div
            class="form-check"
            (click)="
              issueSelection(issue?.key, issue?.label, this.selectedMachineType)
            "
          >
            <input
              class="form-check-input me-2"
              type="radio"
              name="issueRadio"
              [id]="'issue-' + issue?.key"
              [value]="issue?.key"
              [(ngModel)]="issueKey"
              (change)="
                issueSelection(
                  issue?.key,
                  issue?.label,
                  this.selectedMachineType
                )
              "
            />
            <label class="issue-button mt-3" [for]="'issue-' + issue?.key">
              {{ issue?.label[languageIndex] }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Section for EULT Machine Type -->
    <div
      *ngIf="this.selectedMachineType === this.machineType.EULT"
      class="overflow-scroll p-2 header"
    >
      <h2 class="header-text">{{ translations['whats_going_on'] }}</h2>
      <div class="dishmachine-container">
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'machine_issue'"
          (click)="selectIssueCategory('machine_issue')"
        >
          <img
            src="assets/images/troubleshooting/machine_issue.png"
            alt="Machine Issue"
          />
          <span>{{ translations['machine_issue'] }}</span>
        </div>
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'poor_results'"
          (click)="poorResults()"
        >
          <img
            src="assets/images/troubleshooting/poor_result.png"
            alt="Poor Result"
          />
          <label>{{ translations['poor_results'] }}</label>
        </div>
      </div>

      <div *ngIf="selectedIssueCategory === 'machine_issue'">
        <div *ngFor="let issue of issuesEult">
          <div
            class="form-check"
            (click)="
              issueSelection(issue?.key, issue?.label, this.machineType.EULT)
            "
          >
            <input
              class="form-check-input me-2"
              type="radio"
              name="exampleRadios"
              [id]="'issue-' + issue?.key"
              [value]="issue?.key"
              [(ngModel)]="issueKey"
              (change)="
                issueSelection(issue?.key, issue?.label, this.machineType.EULT)
              "
            />
            <label class="issue-button mt-3" [for]="'issue-' + issue?.key">{{
              issue?.label[languageIndex]
            }}</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Section for ELT Machine Type -->
    <div
      *ngIf="selectedMachineType === this.machineType.ELT"
      class="overflow-scroll p-2 header"
    >
      <h2 class="header-text">{{ translations['whats_going_on'] }}</h2>
      <div class="dishmachine-container">
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'machine_issue'"
          (click)="selectIssueCategory('machine_issue')"
        >
          <img
            src="assets/images/troubleshooting/machine_issue.png"
            alt="Machine Issue"
          />
          <span>{{ translations['machine_issue'] }}</span>
        </div>
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'poor_results'"
          (click)="poorResults()"
        >
          <img
            src="assets/images/troubleshooting/poor_result.png"
            alt="Poor Result"
          />
          <label>{{ translations['poor_results'] }}</label>
        </div>
      </div>

      <div *ngIf="selectedIssueCategory === 'machine_issue'">
        <div *ngFor="let issue of issuesElt">
          <div
            class="form-check"
            (click)="
              issueSelection(issue?.key, issue?.label, this.machineType.ELT)
            "
          >
            <input
              class="form-check-input me-2"
              type="radio"
              name="exampleRadios"
              [id]="'issue-' + issue?.key"
              [value]="issue?.key"
              [(ngModel)]="issueKey"
              (change)="
                issueSelection(issue?.key, issue?.label, this.machineType.ELT)
              "
            />
            <label class="issue-button mt-3" [for]="'issue-' + issue?.key">{{
              issue?.label[languageIndex]
            }}</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Section for EUHT Machine Type -->
    <div
      *ngIf="this.selectedMachineType === this.machineType.EUHT"
      class="overflow-scroll p-2 header"
    >
      <h2 class="header-text">{{ translations['whats_going_on'] }}</h2>
      <div class="dishmachine-container">
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'machine_issue'"
          (click)="selectIssueCategory('machine_issue')"
        >
          <img
            src="assets/images/troubleshooting/machine_issue.png"
            alt="Machine Issue"
          />
          <span>{{ translations['machine_issue'] }}</span>
        </div>
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'poor_results'"
          (click)="poorResults()"
        >
          <img
            src="assets/images/troubleshooting/poor_result.png"
            alt="Poor Result"
          />
          <label>{{ translations['poor_results'] }}</label>
        </div>
      </div>

      <div *ngIf="selectedIssueCategory === 'machine_issue'">
        <div *ngFor="let issue of issuesEuht">
          <div
            class="form-check"
            (click)="
              issueSelection(issue?.key, issue?.label, this.machineType.EUHT)
            "
          >
            <input
              class="form-check-input me-2"
              type="radio"
              name="exampleRadios"
              [id]="'issue-' + issue?.key"
              [value]="issue?.key"
              [(ngModel)]="issueKey"
              (change)="
                issueSelection(issue?.key, issue?.label, this.machineType.EUHT)
              "
            />
            <label class="issue-button mt-3" [for]="'issue-' + issue?.key">{{
              issue?.label[languageIndex]
            }}</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Section for EH500S Machine Type -->
    <div
      *ngIf="this.selectedMachineType === this.machineType.EH500S"
      class="overflow-scroll p-2 header"
    >
      <h2 class="header-text">{{ translations['whats_going_on'] }}</h2>
      <div class="dishmachine-container">
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'machine_issue'"
          (click)="selectIssueCategory('machine_issue')"
        >
          <img
            src="assets/images/troubleshooting/machine_issue.png"
            alt="Machine Issue"
          />
          <span>{{ translations['machine_issue'] }}</span>
        </div>
        <div
          class="card"
          [class.selected]="selectedIssueCategory === 'result_issue'"
          (click)="selectResultIssue('result_issue')"
        >
          <img
            src="assets/images/troubleshooting/poor_result.png"
            alt="Poor Result"
          />
          <label>{{ translations['poor_results'] }}</label>
        </div>
      </div>

      <div *ngIf="selectedIssueCategory === 'machine_issue'">
        <div *ngFor="let issue of issuesEh500s">
          <div
            class="form-check"
            (click)="
              issueSelection(issue?.key, issue?.label, this.machineType.EH500S)
            "
          >
            <input
              class="form-check-input me-2"
              type="radio"
              name="exampleRadios"
              [id]="'issue-' + issue?.key"
              [value]="issue?.key"
              [(ngModel)]="issueKey"
              (change)="
                issueSelection(
                  issue?.key,
                  issue?.label,
                  this.machineType.EH500S
                )
              "
            />

            <label class="issue-button mt-3" [for]="'issue-' + issue?.key">
              {{ issue?.label }}
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="selectedIssueCategory === 'result_issue'">
        <div *ngFor="let issue of resultIssuesEh500s">
          <div
            class="form-check"
            (click)="
              resultIssueSelection(
                issue?.key,
                issue?.label,
                this.machineType.EH500S
              )
            "
          >
            <input
              class="form-check-input me-2"
              type="radio"
              name="exampleRadios"
              [id]="'issue-' + issue?.key"
              [value]="issue?.key"
              [(ngModel)]="issueKey"
              (change)="
                resultIssueSelection(
                  issue?.key,
                  issue?.label,
                  this.machineType.EH500S
                )
              "
            />

            <label class="issue-button mt-3" [for]="'issue-' + issue?.key">
              {{ issue?.label }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="d-grid gap-2 btn-container" *ngIf="showNextButton">
      <button
        type="button"
        class="next btn btn-primary btn-block"
        [ngClass]="{ disabled: !issueKey }"
        (click)="next()"
      >
        {{ translations['next'] }}
      </button>
    </div>
  </div>
</div>
